export enum SaldoTipoMovimiento {
	Generacion = 1,
	Aplicacion = 3,
	Ajuste = 5,
	Devolucion = 6,
}

export interface SaldoMovimiento {
	saldoMovimientoId: string;
	tipo: SaldoTipoMovimiento;
	monto: number;
	montoConSigno: number;
	moneda: string;
	ajusteEsCredito: boolean | null;
	origen: number;
	claveIdempotencia: string;
	destino: number | null;
	emisorId: string;
	empresaRazonSocial: string | null;
	empresaRut: string | null;
	cotizacionPlanId: string | null;
	ordenCompraId: string | null;
	transaccionPagoId: string | null;
	facturaOrigenId: string | null;
	emisorAdicionalOrigenId: string | null;
	certificacionOrigenId: string | null;
	referenciaExterna: string | null;
	motivo: string | null;
	fechaMovimiento: Date;
}

export interface SaldoMovimientosPaginados {
	items: SaldoMovimiento[];
	total: number;
	pagina: number;
	tamanoPagina: number;
}
